import React from "react";
import "../assets/css/phoneFooter.css";
import phoneIconYellow from "../assets/img/phoneIconYellow.svg";
import phoneIconBlack from "../assets/img/phoneIcon.svg";

const PhoneFooter = (data) => {

  let phone = data.data.phoneNumber
  let numberIcon = data.data.phoneNumberIcon

  return (
    <div className="floating-button" type="button">
      <div className="button-title">
        <img src={phoneIconYellow} alt="Phone" className="phoneIconWeb" />
        <img src={phoneIconBlack} alt="Phone" className="phoneIconMobile" />
        <p>Llamanos</p>
      </div>
      <a href={`tel:${phone}`}>
        <b>{numberIcon}</b>
      </a>
    </div>
  );
};

export default PhoneFooter;
